import axios, { AxiosRequestConfig } from "axios";
import EncryptionUtils from "./encryptionUtils";
const hostname = window.location.hostname;
const BASE_URL = hostname === "localhost" ? "http://localhost:8081" : hostname === "dev.admin.auditzen.ai" ? "https://dev.admin.api.auditzen.ai" : hostname === "qa.admin.auditzen.ai" ? "https://qa.admin.api.auditzen.ai" : hostname === "https://admin.auditzen.ai" ? "https://admin.api.auditzen.ai" : "https://admin.api.auditzen.ai";
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
});
export const s3AxiosInstance = axios.create();
const setAuthHeaders = () => {
  let token = localStorage.getItem("accessToken");
  if (token) {
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      if (payload?.sub) {
        EncryptionUtils.setLocalStorage("email", payload.sub || "");
      }
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  } else {
    delete axiosInstance.defaults.headers.common["Authorization"];
    EncryptionUtils.removeLocalStorage("email");
  }
};
const handleUnauthorizedOrForbidden = () => {
  ["accessToken", "email"].forEach(key => localStorage.removeItem(key));
  const modal = document.createElement("div");
  modal.innerHTML = `
    <div id="session-modal" style="
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
      opacity: 0;
      animation: fadeIn 0.3s ease-in-out forwards;
    ">
      <div id="modal-content" style="
        background: white;
        padding: 20px;
        font-weight: bolder;
        border-radius: 8px;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        text-align: center;
        width: 300px;
        transform: scale(0.8);
        animation: scaleUp 0.3s ease-in-out forwards;
      ">
        <h3 style="color: red;">Session Expired</h3>
        <p>Your session has expired. Redirecting...</p>
      </div>
    </div>
    <style>
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleUp {
        from { transform: scale(0.8); }
        to { transform: scale(1); }
      }
    </style>
  `;
  document.body.appendChild(modal);
  setTimeout(() => {
    window.location.reload();
  }, 1500);
};
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      handleUnauthorizedOrForbidden();
    }
    return Promise.reject(error);
  }
);
export const apiCall = async (
  method: "get" | "post" | "put" | "patch" | "delete",
  endpoint: string,
  data?: any,
  params?: any,
  config?: AxiosRequestConfig,
  isS3Request: boolean = false
): Promise<any> => {
  try {
    if (!isS3Request) {
      setAuthHeaders();
    }
    const instance = isS3Request ? s3AxiosInstance : axiosInstance;
    const response = await instance({
      method,
      url: endpoint,
      params,
      data,
      ...config,
    });
    return response.data;
  } catch (error: any) {
    console.error(`API Error (${endpoint}):`, error.response?.data || error.message);
    throw error;
  }
};